import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { getOtpSchema } from '@dxb-web-ui-framework/content-composer/components/FormBuilder/formElements/OtpInput';
import { OTPActionButtons, ResendOTPCodeButton } from './OTP';

const submitDataAdapter = (data: GenericObject, authorizationId?: number) => ({
  dynamicPath: authorizationId,
  data: { code: Object.values(data).join('') },
});

type inApp2FAConfigData = {
  authorizationId?: number;
};

const inApp2FAConfig = ({ authorizationId }: inApp2FAConfigData) => ({
  validationSchema: {
    otpCode1: getOtpSchema({}),
    otpCode2: getOtpSchema({}),
    otpCode3: getOtpSchema({}),
    otpCode4: getOtpSchema({}),
    otpCode5: getOtpSchema({}),
    otpCode6: getOtpSchema({}),
  },
  components: [
    {
      type: 'fieldSet',
      key: 'fieldSet',
      components: [
        {
          type: 'otpCode',
          key: 'otpCode1',
          defaultValue: '',
          validate: {
            required: true,
          },
          validateOn: 'onChange',
          properties: {
            variant: 'filled',
            shouldAutoFocusNextInput: true,
            mr: 1,
            showNumbers: true,
            shouldGroupValidation: true,
          },
        },
        {
          type: 'otpCode',
          key: 'otpCode2',
          defaultValue: '',
          validate: {
            required: true,
          },
          validateOn: 'onChange',
          properties: {
            variant: 'filled',
            shouldAutoFocusNextInput: true,
            mr: 1,
            showNumbers: true,
            shouldGroupValidation: true,
          },
        },
        {
          type: 'otpCode',
          key: 'otpCode3',
          defaultValue: '',
          validate: {
            required: true,
          },
          validateOn: 'onChange',
          properties: {
            variant: 'filled',
            shouldAutoFocusNextInput: true,
            mr: 1,
            showNumbers: true,
            shouldGroupValidation: true,
          },
        },
        {
          type: 'otpCode',
          key: 'otpCode4',
          defaultValue: '',
          validate: {
            required: true,
          },
          validateOn: 'onChange',
          properties: {
            variant: 'filled',
            shouldAutoFocusNextInput: true,
            mr: 1,
            showNumbers: true,
            shouldGroupValidation: true,
          },
        },
        {
          type: 'otpCode',
          key: 'otpCode5',
          defaultValue: '',
          validate: {
            required: true,
          },
          validateOn: 'onChange',
          properties: {
            variant: 'filled',
            shouldAutoFocusNextInput: true,
            mr: 1,
            showNumbers: true,
            shouldGroupValidation: true,
          },
        },
        {
          type: 'otpCode',
          key: 'otpCode6',
          defaultValue: '',
          validate: {
            required: true,
          },
          validateOn: 'onChange',
          properties: {
            variant: 'filled',
            shouldAutoFocusNextInput: false,
            showNumbers: true,
            shouldGroupValidation: true,
          },
        },
      ],
      properties: {
        shouldGroupValidation: true,
        isRow: true,
      },
    },
    {
      type: 'dynamicComponent',
      key: 'dynamicComponent',
      properties: {
        component: ResendOTPCodeButton,
      },
    },
    {
      type: 'dynamicComponent',
      key: 'dynamicComponent',
      properties: {
        component: OTPActionButtons,
      },
    },
  ],
  submitDataAdapter: (data: GenericObject) => submitDataAdapter(data, authorizationId),
});

export { inApp2FAConfig };
